export const PERIOD_UNITS = {
  DAY: "day",
  WEEK: "week"
};
